import i18n from '@/i18n';

export default () => {
  const t = i18n.global.t as (val: string, pluralNumber?: number) => string;

  return {
    t,
  };
};
